//window.$ = window.jQuery = require('jquery')

import Header from './../Header.js'
import Modal from './../Modal.js'
import Quantity from './../Quantity.js'
import Common from './../Common.js'
import Stories from './../Stories.js'

$(function () {
    $('html').removeClass('no-js')

    setTimeout(() => {
        $('html').removeClass('no-transitions')
    }, 250)

    const moduleHeader = new Header()
    moduleHeader.init()

    const moduleModal = new Modal()
    moduleModal.init()

    const moduleQuantity = new Quantity()
    moduleQuantity.init()

    const moduleCommon = new Common()
    moduleCommon.init()

    const moduleStories = new Stories()
    moduleStories.init()
})
